// @flow
import React from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import PopupFooter from '../common/components/popup/PopupFooter';
import withLocalized from '../localization/withLocalized';
import { APP_VARIANT } from 'config'

const StyledContent = styled.div`
  text-align: left;
  a {
    color: ${({theme}) => theme.HeadingColor};
  }

  header {
    max-width: 80%;
    margin: 0 auto;
    margin-bottom: 3rem;
    h3 {
      font-size: 1.45rem;
      font-weight: 700;
      margin-bottom: 1rem;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 1em;
  }

  ul, ol{
    margin-left: 0;
    padding-left: 0;
    list-style-position: inside;
    strong{
      color: ${({theme}) => theme.HeadingColor};
    }
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({theme}) => theme.HeadingColor};
    margin-bottom: 1rem;
    margin-top: 2rem;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  h3 {
    font-size: 1.35rem;
  }

  h4 {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  h5 {
    font-size: 1.15rem;
  }

  h6 {
    font-size: 1.0rem;
  }

  p strong {
    font-weight: 700;
  }

  a {
    text-decoration: none;
  }

  h1:first-of-type {
    margin-top: 0;
  }

  section {
    h4 {
      font-weight: 700;
      color: ${({theme}) => theme.HeadingColor};
    }
    ul {
      li {
        margin-bottom: 1rem;
      }
    }
  }
`;

const BookingTerms = (props) => {
  const { localized } = props;
  const terms = APP_VARIANT === 'goplaygolf' ? localized('booking.terms.html_content_gpg') : localized('booking.terms.html_content')
  return (
    <div>
      <StyledContent dangerouslySetInnerHTML={{ __html: terms }} />
      {!props.skipFooter && (
        <PopupFooter
          linkLabel={localized('booking.form.label_help')}
          linkTarget={{
            pathname: `${props.linkRoot}/help`,
            state: {modal:true}
          }}
        />
      )}
    </div>
  );
};

export default withLocalized(withRouter(BookingTerms));



// WEBPACK FOOTER //
// ./src/modules/booking/BookingTerms.js